import { InjectionToken } from '@angular/core';

import { IServicenowVirtualAgentConfig } from './interfaces/servicenow-virtual-agent.interface';

export const SERVICENOW_VIRTUAL_AGENT_CONFIG_TOKEN =
  new InjectionToken<IServicenowVirtualAgentConfig>(
    'ServiceNow Virtual Agent Config',
  );
